export const PAYMENT_STATUS_SUCCESS = 'success';
export const PAYMENT_STATUS_FAILURE = 'failure';

export const PAYMENT_STATUS_LABEL_SUCCESS = 'SUCCESS';
export const PAYMENT_STATUS_LABEL_FAILURE = 'FAILURE';
export const PAYMENT_STATUS_PENDING = 'PENDING';
export const PAYMENT_STATUS_REFUSED_CM = 'REFUSED_CM';
export const PAYMENT_STATUS_REFUSED_PSP = 'REFUSED_PSP';
export const PAYMENT_STATUS_CANCELED = 'CANCELED';
export const PAYMENT_TYPE_BOOKING = 'BOOKING';
export const PAYMENT_TYPE_OPTION = 'OPTION';

export const PAYMENT_ACTION = {
  PAYMENT_OPTION: 'PAYMENT_OPTION',
  PAYMENT_SOLDE: 'PAYMENT_SOLDE',
  PAYMENT_PARTIAL: 'PAYMENT_PARTIAL',
  PAYMENT_RESA: 'PAYMENT_RESA',
  PAYMENT_CART: 'PAYMENT_CART',
  PAYMENT_UPGRADE_ROOM: 'PAYMENT_UPGRADE_ROOM',
  PAYMENT_SERVICES_IN_OPTION: 'PAYMENT_SERVICES_IN_OPTION',
};

export const API_PAYMENT_STATUS_SUCCESS = 'OK';
export const API_PAYMENT_STATUS_FAILURE = 'FAILED';
export const API_PAYMENT_STATUS_REFUSED_CM = 'REFUSED_CM';
export const API_PAYMENT_STATUS_REFUSED_PSP = 'REFUSED_PSP';
export const API_PAYMENT_STATUS_PENDING = 'PENDING';
export const API_PAYMENT_STATUS_PENDING_PSP = 'PENDING_PSP';
export const API_PAYMENT_STATUS_CANCELED = 'CANCELED';

export const PAYMENT_ID_OGONE = 'EOGONE';
export const PAYMENT_ID_ALIPAY = 'EALIPAY';
export const PAYMENT_ID_CUP = 'ECUP';
export const PAYMENT_ID_WECHAT = 'EWECHAT';
export const PAYMENT_ID_99BILL = 'E99BILL';

export const DONATION_STORAGE_KEY = 'donation';
export const JOYVIEW_UPSELL_STORAGE_KEY = 'joyview_upsell';
export const JOYVIEW_UPSELL_RON_PACKAGEID = 'RON';

export const PAYMENT_METHOD_ID_DIRECT_DEBIT = 'AK';
